module.exports = __webpack_public_path__ + "img/emo_57.b0f285b5.gif";